<template>
	<div class="diagnostic-records">
		<div class="diagnostic-records-container">
			<div class="diagnostic-records-content">
				<div class="record-group">
					<h3 class="moudleDefaultTitle">资质诊断记录</h3>
					<!-- 展示诊断记录 -->
					<diagnostic-records :matters-type="mattersType" :more-records="true"></diagnostic-records>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DiagnosticRecords from './materialsRecord/diagnosticRecords'

	// 更多诊断记录
	export default {
		name: 'DiagnosticRecordsMore',
		components: {
			DiagnosticRecords
		},
		props: {},
		data() {
			return {
				/**
				 * 类型，传递不同发类型编码。
				 * 首次申请：SCSQ
				 * 升级：SJ
				 * 增项：ZX
				 * 延续：YX
				 * 重新核定：CXHD
				 */
				mattersType: ''
			}
		},
		computed: {},
		watch: {},
		created() {
			this.mattersType = this.$route.params.mattersType || ''
		},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.diagnostic-records {
		.diagnostic-records-container {
			background-color: #eaf2f7;
			padding: 20px 0 40px;

			.diagnostic-records-content {
				width: $main-page-width;
				margin: 0 auto;

				.record-group {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;
				}
			}
		}
	}
</style>
